import { render, staticRenderFns } from "./ContentCategoryDetailView.vue?vue&type=template&id=6f4f4d0e&scoped=true"
import script from "./ContentCategoryDetailView.vue?vue&type=script&lang=js"
export * from "./ContentCategoryDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f4d0e",
  null
  
)

export default component.exports